import { __assign } from "tslib";
import { AppEventType } from './app';
import { PublicEventType } from './public';
import { sanitizePII } from '@wix/bi-logger-sanitizer';
export * from './app';
export * from './handler';
export * from './utils/pseudonymous-id';
export * from './utils/error-types';
export * from './public';
export * from './test-utils';
export var createConsoleHandler = function () {
    return function (event) {
        // tslint:disable-next-line:no-console
        // tslint:disable-next-line:max-line-length
        console.groupCollapsed("[Logger] " + (AppEventType[event.type] || PublicEventType[event.type] || event.type));
        // tslint:disable-next-line:no-console
        // console.log('Called with:');
        // tslint:disable-next-line:no-console
        // console.log(event.data);
        console.groupEnd();
        return Promise.resolve();
    };
};
var sanitizeParams = function (params) {
    switch (typeof params) {
        case 'object':
            var newParams_1 = __assign({}, params);
            Object.keys(params).forEach(function (key) {
                newParams_1[key] = sanitizePII(newParams_1[key]);
            });
            return newParams_1;
        case 'string':
            return sanitizePII(params);
        default:
            return params;
    }
};
export var createLogger = function (handlers, errorHandler) {
    var logEvent = function (event) {
        var sanitizedEvent = event.data ? __assign(__assign({}, event), { data: sanitizeParams(event.data) }) : event;
        handlers.forEach(function (handler) {
            try {
                handler(sanitizedEvent);
            }
            catch (e) {
                if (errorHandler) {
                    errorHandler(e);
                }
                else {
                    // tslint:disable-next-line:no-console
                    console.error('error with log handler', e);
                }
            }
        });
    };
    return {
        logArticleLinkInTicket: function (article, meta) {
            var event = {
                type: AppEventType.ARTICLE_LINKED_TO_TICKET,
                data: { article: article, meta: meta }
            };
            logEvent(event);
        },
        dev: function (module, feature, eventKey, params) {
            if (params === void 0) { params = {}; }
            var event = {
                type: AppEventType.ALPHA_EVENT,
                data: {
                    module: module,
                    feature: feature,
                    type: eventKey,
                    params: sanitizeParams(params)
                }
            };
            logEvent(event);
        },
        logEvent: logEvent
    };
};
//# sourceMappingURL=index.js.map